import { useFormikContext } from "formik";
import { MDBRow } from "mdb-react-ui-kit";
import AuthCode from "react-auth-code-input";
import Row from "./row";
import Col from "./col";

export default function Code({ name, className, disabled }) {
  const formik = useFormikContext();

  const handleChange = (e) => {
    formik?.setFieldValue(name, e);
  };

  return (
    <Col>
      <Row className={`element _code ${className ? className : ""}`}>
        <article className="code-row">
          <AuthCode
            length={6}
            autoFocus={false}
            isPassword={true}
            disabled={disabled}
            allowedCharacters="numeric"
            onChange={(e) => handleChange(e)}
          />
        </article>
      </Row>
      <Row>
        {formik?.errors && formik?.errors[name] ? (
          <div className="element _errors">{formik.errors[name]}</div>
        ) : null}
      </Row>
    </Col>
  );
}
